/*! @azure/msal-common v7.0.0 2022-06-13 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "7.0.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
